import { translate } from '@vimeo/i18n-runtime';

export const T = {
  EmailText: translate('Add emails'),
  Share: translate('Share'),
  CopyLink: translate('Copy link'),
  Copied: translate('Copied!'),
  OptionalMsg: translate('Message (optional)'),
  Cancel: translate('Cancel'),
  Send: translate('Send'),
  Email: translate('Email'),
  ErrorMsg: translate('Oops, something went wrong.'),
  Characters: translate('characters'),
  InvalidEmail: translate('Not a valid email'),
};

export const THROTTLE_TIME = 50;
export const MESSAGE_CHAR_LIMIT = 4096;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
